import React, {Component} from 'react';
import {translate} from 'react-i18next';
import ShippingsNew from './createShipping';
import ModalDespatch from './modalDespatch';

class FormSendDespatch extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.loadDespatch = this.loadDespatch.bind(this);

		this.state = {
			option: "",
			show_form:false,
		}
	}

	componentDidMount(){

	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.value === 'despatch'){
			this.modal.handleShow();
		}else{
			this.setState({show_form:false});
			this.props.match.params = {};
		}
	}

	loadDespatch(id){
		this.props.match.params.id = id;

		this.setState({show_form:true});
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return (
			<div className="col-xs-12"> 
				<div className="route">
					<h5 className="title_page" >
						<div>
							{session} ->
							{t('sidebar.nav.home.MAIN')} -> 
							{t('sidebar.nav.distribution.MAIN')} ->
							Envío de unidades
						</div>
					</h5>
				</div>
				<ShippingsNew {...this.props} onRef={ref => (this.shipping_new = ref)} />
				

			 	<ModalDespatch loadDespatch={this.loadDespatch} {...this.props} onRef={ref => (this.modal = ref)} />
			</div>
		)
	}
}

export default translate('translations')(FormSendDespatch);